import { render, staticRenderFns } from "./insClass.vue?vue&type=template&id=5145273c&"
import script from "./insClass.vue?vue&type=script&lang=js&"
export * from "./insClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports